import { Constants } from 'helpers';
export const initialState = {
  landingPages: [],
  landingPage: {},
  currentPage: 1,
  pageSize: 10,
  filterSearchText: "",
  filterModel: [],
  landingPageDraftName: "",
  isLoading: false,
  beePluginLoading: false,
  rowData: [],
  showFilterModal: false,
  totalRow: 0,
  beeEditor: undefined,
  jsonTemplate: null,
  onNextChange: null,
  hasChanges: false,
  activeLandingPageTab: "tab_landing_page_editor",
  landingPageDns: "",
  landingPageUrl: "",
  landingPageDescription: "",
  landingPageCategories: [],
  html: "",
  subdomain: "",
  companySubdomainId: "",
  companyCustomDomainId: "",
  category: "",
  isFromTemplate: false,
  subdomains: [],
  isLoadingSubdomains: false,
  state: "draft",
  googleAnalytics: "",
};


export const templateInitialState = {
  templateLandingPages: [],
  templateLandingPage: {},
  templateCurrentPage: 1,
  templatePageSize: 10,
  templateFilterSearchText: "",
  templateFilterModel: [],
  templateLandingPageDraftName: "",
  templateIsLoading: false,
  templateBeePluginLoading: false,
  templateShowFilterModal: false,
  templateTotalRow: 0,
  templateBeeEditor: undefined,
  templateActiveLandingPageTab: "tab_landing_page_editor_template",
  templateDefaultLandingPageTab: "tab_landing_page_editor_pre_design_template",
  templateHasChanges: false,
  templateLandingPageUrl: "",
  templateLandingPageDescription: "",
  templateLandingPageCategories: [],
  isShowWizardModal: false,
  templateHtml: "",
  templateSubdomain: "",
  templateCategory: "",

  // Bee templates state
  beeTemplates: [],
  beeTemplatesLoading: false,
  beeTemplatesError: null,
  beeTemplatesPage: 1,
  beeTemplatesTotalCount: 0,
  beeTemplatesNext: null,
  beeTemplatesPrevious: null,
  beeTemplatesFacets: {},
  selectedBeeTemplateCategories: [],
  selectedCategories: [],
  searchTerm: "",

  // Bee categories state (like email store)
  beeCategories: [],
  beeCategoriesLoading: false,
  beeCategoriesError: null
};
